import { Button } from "@progress/kendo-react-buttons";
import { GridCustomCellProps } from "@progress/kendo-react-grid";
import { OrderServiceExceptionViewModel } from "TypeGen/ServiceExceptions/order-service-exception-view-model";
import { ILink } from "types/link";
import { dateFormatter } from "utils/utils";

type Props = {
  assign: (link: ILink) => void;
  reassign: (link: ILink, userId: string) => void;
} & GridCustomCellProps;

export const AssignedCell = (props: Props) => {
  const data = props.dataItem as OrderServiceExceptionViewModel;

  const assignLink = data.Links.find(l => l.Name === "Assign");
  if (assignLink) {
    return <td {...props.tdProps}>
      <Button size="small" fillMode="flat" themeColor="primary" onClick={() => props.assign(assignLink)}>Assign</Button>
    </td>
  }

  const reassignLink = data.Links.find(l => l.Name === "Reassign");
  if (reassignLink) {
    return <td {...props.tdProps}>
      <a href="#" style={{ color: '#007bff' }} title="Reassign" onClick={(e) => {
        e.preventDefault();
        props.reassign(reassignLink, data.AssignedToUserID);
      }}>{data.AssignedToUserFullName}</a><br />
      {dateFormatter(data.AssignedDateTime)}
    </td>;
  }

  if (data.AssignedToUserFullName) {
    return <td {...props.tdProps}>
      {data.AssignedToUserFullName}<br />
      {dateFormatter(data.AssignedDateTime)}
    </td>;
  }

  return <td {...props.tdProps} />;
}